module.exports = __webpack_public_path__ + "img/9.914810ec.png";